const ModalCommonProps = {
  props: {
    showModal: {
      type: Boolean,
      default: true,
    },
    closeHandler: {
      type: Function,
      required: true,
    },
    modalOptions: {
      type: Object,
      default: null,
    },
    modalData: {
      type: Object,
      default: null,
    },
  },
};

export default ModalCommonProps;
